/**
 * Helpers for POST /api/refinery — list, show, create, update.
 */

import { extractListRowsFromResponse } from "./parseApiPagination";

const num = (v, fallback = 0) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : fallback;
};

export const isRefineryApiSuccess = (res) =>
  res &&
  (res.success === true ||
    String(res.status || "").toLowerCase() === "success" ||
    res.message === "radha");

export function createRefineryIdempotencyKey() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

/** Normalize list endpoint rows for RefineryTable. */
export function normalizeListRefineryRows(res) {
  if (!isRefineryApiSuccess(res)) return [];

  const rows = extractListRowsFromResponse(res, ["refineries"]);

  return rows.map((row) => ({
    id: row.id,
    doc_number: row.doc_number || "",
    doc_date: row.doc_date || "",
    fiscal_year_label: row.fiscal_year_label || "",
    remarks: row.remarks ?? "",
    status: row.status || "",
    supplier_id: row.supplier_id ?? null,
    supplier_name: row.supplier_name || "",
    item_count: row.item_count ?? 0,
    total_fine_wt: row.total_fine_wt ?? "",
    total_pcs: row.total_pcs ?? 0,
  }));
}

/** Map show response to form / view state. */
export function mapRefineryShowToForm(res) {
  const doc = res?.data?.refinery_document ?? res?.data ?? null;
  if (!doc) return null;

  const items = Array.isArray(doc.items) ? doc.items : [];

  return {
    id: doc.id,
    doc_number: doc.doc_number || "",
    doc_date: doc.doc_date || "",
    fiscal_year_label: doc.fiscal_year_label || "",
    remarks: doc.remarks ?? "",
    status: doc.status || "",
    supplier_id: doc.supplier_id ?? null,
    supplier_name: doc.supplier_name || "",
    supplier_mobile: doc.supplier_mobile || "",
    supplier_address: doc.supplier_address || "",
    supplier_city: doc.supplier_city || "",
    supplier_state: doc.supplier_state || "",
    supplier_gst_number: doc.supplier_gst_number || "",
    supplier_pan_card:
      doc.supplier_pan_card || doc.supplier_pan_number || doc.supplier_pan || "",
    item_count: doc.item_count ?? items.length,
    total_fine_wt: doc.total_fine_wt ?? "",
    total_pcs: doc.total_pcs ?? items.length,
    version: doc.version,
    items: items.map((item, idx) => ({
      id: item.id ?? `line-${idx}`,
      line_no: item.line_no ?? idx + 1,
      product_group_id: item.product_group_id ?? null,
      product_group_name: item.product_group_name || "",
      item_category_name:
        item.item_category_name ||
        item.itemCategoryName ||
        item.product_group_name ||
        "",
      hsn: item.hsn ?? "",
      gwt: item.gwt ?? "",
      nwt: item.nwt ?? "",
      touch: item.touch ?? "",
      fine_wt: item.fine_wt ?? "",
      conv_item: item.conv_item ?? "",
      total_wt: item.total_wt ?? "",
      pcs: 1,
    })),
  };
}

/** Map socket payload to list table row. */
export function refinerySocketPayloadToTableRow(payload) {
  if (!payload || typeof payload !== "object") return null;

  const doc =
    payload.refinery_document ??
    payload.refinery ??
    payload.data?.refinery_document ??
    payload.data ??
    payload;

  if (!doc?.id) return null;

  return {
    id: doc.id,
    doc_number: doc.doc_number || "",
    doc_date: doc.doc_date || "",
    fiscal_year_label: doc.fiscal_year_label || "",
    remarks: doc.remarks ?? "",
    status: doc.status || "",
    supplier_id: doc.supplier_id ?? null,
    supplier_name: doc.supplier_name || "",
    item_count: doc.item_count ?? 0,
    total_fine_wt: doc.total_fine_wt ?? "",
    total_pcs: doc.total_pcs ?? num(doc.item_count, 0),
  };
}
